export default {
  description: 'Vlozte JSON pre RenderRoot alebo jeden renderovaci element a zobrazte nahlad.',
  jsonInputPlaceholder: 'Sem vlozte JSON RenderRoot alebo renderovacieho elementu',
  validationErrorSummary: 'Nahlad nie je k dispozicii',
  errors: {
    emptyInput: 'Vstup je prazdny. Vlozte JSON a spustite nahlad.',
    unknownJsonError: 'Neznama chyba pri parsovani JSON.',
    invalidJson: 'Neplatna syntax JSON: {details}',
  },
};
